import { render, staticRenderFns } from "./CenterViewPreview2d_Ap.vue?vue&type=template&id=48b0f333&scoped=true"
import script from "./CenterViewPreview2d_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewPreview2d_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewPreview2d_Ap.vue?vue&type=style&index=0&id=48b0f333&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b0f333",
  null
  
)

export default component.exports